// extracted by mini-css-extract-plugin
module.exports = {"InputStyle":"Input_InputStyle__2Z72v"};